import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import { ZrSwal } from 'utils'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

const BotonesEnvioSection = ({ documentos, enviarCorreoAutomatico, repetirConsultaDocumentos }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickEnviarCorreosFaltantes = React.useCallback(() => {
    FacturacionHistorialService.enviarCorreosFaltantes({
      ids: documentos.map(x => x._id)
    })
      .then(() => {
        __zariContext.snack('success', 'Correos enviado!')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, documentos])

  const enviarAOSEClick = React.useCallback(() => {
    const checkedDocs = documentos.filter(x => x.checked)

    if (checkedDocs.length === 0) {
      __zariContext.snack('error', 'Seleccionar documentos a enviar.')
      return
    }

    if (checkedDocs.filter(x => x.estadoOSE === EstadosOSE.ENPROCESO || x.estadoOSE === EstadosOSE.PROCESADO).length > 0) {
      __zariContext.snack('error', 'No se puede emitir documentos con estado PENDIENTE o ACEPTADO.')
      return
    }

    ZrSwal.showAlert({
      tipo: 'info',
      mensaje: `Se comunicarán ${checkedDocs.length} documentos a SUNAT. Desea continuar?`,
      onSuccess: () => {
        __zariContext.loader.open(`Enviando ${checkedDocs.length} documentos a SUNAT. `)
        FacturacionHistorialService.enviarDocumentosxIds({ ids: checkedDocs.map(x => x._id), flagEnviarCorreoAutomatico: enviarCorreoAutomatico })
          .then(({ data }) => {
            __zariContext.snack(
              'success',
              <>
                <span>Proceso de envío culminado.</span> <br />
                <span>{`${data.cantidadSolicitudes} documentos solicitados.`}</span> <br />
                <span>{`${data.cantidadEmitidos} documentos emitidos con CDR.`}</span> <br />
                <span>{`${data.cantidadEmitidosSinCdr} documentos emitidos sin CDR.`}</span>
              </>
            )
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
          })
          .finally(() => {
            __zariContext.loader.close()
            repetirConsultaDocumentos()
          })
      },
      showCerrar: true
    })
  }, [__zariContext, documentos, enviarCorreoAutomatico, repetirConsultaDocumentos])

  return (
    <Row>
      <Col sm={6} className='px-2 mt-2'>
        {documentos.some(x => x.checked) && (
          <Button block onClick={enviarAOSEClick} outline>
            Enviar OSE
          </Button>
        )}
      </Col>
      <Col sm={6} className='px-2 mt-2'>
        <Button block onClick={clickEnviarCorreosFaltantes} outline>
          Enviar Correos a FALTANTES
        </Button>
      </Col>
    </Row>
  )
}

export default React.memo(BotonesEnvioSection)
